// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"82885c66","315":"12b51b5a","378":"b924372b","415":"9887daa1","446":"ac5d1e37","812":"15257083"}[chunkId] + ".chunk.js";
};